import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_WHITELIST_DETAILS } from './url-constants';

type GETWHITELISTDETAIL = ApiEndpointSpecification;
export const GetWhitelistDetailEndpointSpecification: GETWHITELISTDETAIL = {
    url: GET_WHITELIST_DETAILS,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'GetWhitelistDetailRequestParams',
    requestBodySchemaName: 'GetWhitelistDetailRequestBody',
    okResponseSchemaName: 'GetWhitelistDetailOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeGetWhitelistDetail = Helpers.makeApiRequestFn<
    Types.GetWhitelistDetailParams,
    Types.GetWhitelistDetailRequestBody,
    Types.GetWhitelistDetailOkResponse
>(GetWhitelistDetailEndpointSpecification);
